import { Link, withRouter } from 'react-router-dom';
import React, { Component, useEffect, useState } from 'react';

import CommonService from '../../../../services/commonService';
import FailureBody from './components/FailureBody';
import { KuposModalWithButtons } from '../../../common';
import KuposSuccessFailure from '../../../common/KuposSuccessFailure';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import { withTranslation } from 'react-i18next';

var global = window;
let productSubmittedBus = false;

function BookingSuccess({
  loading,
  ticketDetails,
  success,
  history,
  appType,
  t,
  isAtBooking,
  purchaseType,
}) {
  let ecoomerceSaleAdded = '';
  let gtagCalled = '';

  const [showModal, setShowModal] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);

    // console.log('All props in BookingSuccess page are------', this.props);
  }, []);

  const sendData = (ticket, category, isRT = false, returnTicket) => {
    console.log('Ticket for Gtag-------------', ticket);

    if (!productSubmittedBus) {
      window.dataLayer.push({
        event: 'kupos_ecom_event',
        transactionId: isRT ? returnTicket : ticket.pnr_number, // Transaction ID - this is normally generated by your system.
        transactionAffiliation: 'https://kupos.cl', // Affiliation or store name
        transactionTotal: ticket.total_booked_amount, // Grand Total
        transactionTax: '0', // Tax.
        transactionShipping: '0', // Shipping cost
        transactionProducts: [
          {
            sku: ticket.pnr_number, // SKU/code.
            name: category + ' ticket', // Product name.
            category: category, // Category or variation.
            price: ticket.total_booked_amount, // Unit price.
            quantity: Object.keys(ticket.seat_Details.seat_details).length,
          },
        ],
      });

      // window.dataLayer.push({
      //   event: 'purchase_enhanced_conversion',
      //   order_value: ticket.total_booked_amount,
      //   order_id: isRT ? returnTicket : ticket.pnr_number,
      //   currencyCode: 'clp',
      //   enhanced_conversion_data: {
      //     email: 'cust@gmail.com',
      //     phone_number: '99999999999',
      //   },
      // });

      window.gtag('event', 'purchase', {
        event: 'purchase',
        transaction_id: isRT ? returnTicket : ticket.pnr_number, // Transaction ID - this is normally generated by your system.
        affiliation: 'https://www.pullmanbus.cl/', // Affiliation or store name
        value: ticket.total_booked_amount, // Grand Total
        tax: '0', // Tax.
        shipping: '0', // Shipping cost
        currency: 'CLP',
        items: [
          {
            item_id: ticket.pnr_number, // SKU/code.
            item_name: category + ' ticket', // Product name.
            item_category: category, // Category or variation.
            price: ticket.total_booked_amount, // Unit price.
            quantity: Object.keys(ticket.seat_Details.seat_details).length,
            currency: 'CLP',
          },
        ],
      });

      let productPurchase = sessionStorage.getItem('productPurchase');

      if (productPurchase) {
        productPurchase = JSON.parse(productPurchase);
        CommonService.pushProductPurchase(
          productPurchase,
          isRT ? returnTicket : ticket.pnr_number,
          ticket.total_booked_amount,
        );
      }

      productSubmittedBus = true;
    }
  };

  const sendATData = (ticket, category = 'airport-transfer', isRT = false, returnTicket) => {
    console.log('Ticket for Gtag -------------', ticket);
    // console.log(
    //   'Ticket for Gtag lengthhhhhhhhhhh -------------',
    //   Object.keys(ticket.seat_Details.seat_details).length,
    // );

    window.gtag('event', 'purchase', {
      event: 'purchase',
      transaction_id: isRT ? returnTicket : ticket.pnr_id, // Transaction ID - this is normally generated by your system.
      affiliation: 'https://www.pullmanbus.cl/', // Affiliation or store name
      value: ticket.total_amount, // Grand Total
      tax: '0', // Tax.
      shipping: '0', // Shipping cost
      currency: 'CLP',
      items: [
        {
          item_id: ticket.pnr_id, // SKU/code.
          item_name: category + ' ticket', // Product name.
          item_category: category, // Category or variation.
          price: ticket.total_booked_amount, // Unit price.
          quantity: returnTicket
            ? Number(ticket.net_seats) + Number(returnTicket.net_seats)
            : Number(ticket.net_seats),
          currency: 'CLP',
        },
      ],
    });
    window.dataLayer.push({
      event: 'kupos_ecom_event',
      transactionId: isRT ? returnTicket.pnr_id : ticket.pnr_id, // Transaction ID - this is normally generated by your system.
      transactionAffiliation: 'https://www.pullmanbus.com', // Affiliation or store name
      transactionTotal: ticket.total_amount, // Grand Total
      transactionTax: '0', // Tax.
      transactionShipping: '0', // Shipping cost
      transactionProducts: [
        {
          sku: ticket.pnr_id, // SKU/code.
          name: 'airport transfer ticket', // Product name.
          category: 'transfer', // Category or variation.
          price: ticket.total_amount, // Unit price.
          quantity: returnTicket
            ? Number(ticket.net_seats) + Number(returnTicket.net_seats)
            : Number(ticket.net_seats),
        },
      ],
    });
  };

  console.log('Ticket details appType-----------', appType);
  console.log('this.props.purchaseType -----------', purchaseType);

  if (ticketDetails && ticketDetails.seat_Details) {
    // gtag ecommerce event checkout function
    CommonService.googleProductPurchase(
      CommonService.convertBusServiceToGoogleProduct(
        ticketDetails.seat_Details.seat_details,
        ticketDetails,
        appType,
      ),
      ticketDetails.pg_type,
      ticketDetails.total_promo_amount,
      'bus',
      ticketDetails.reservation_id,
    );

    //gtag Raqib

    if (!productSubmittedBus) {
      if (ticketDetails && ticketDetails.return_ticket) {
        sendData(ticketDetails, appType, true, window.location.pathname.split('/')[3]);
      } else {
        sendData(ticketDetails, appType, false, null);
      }
      //   // ecoomerceSaleAdded = true;
      productSubmittedBus = true;
    }

    // return
    if (ticketDetails.return_ticket && ticketDetails.return_ticket.seat_Details) {
      CommonService.googleProductPurchase(
        CommonService.convertBusServiceToGoogleProduct(
          ticketDetails.return_ticket.seat_Details.seat_details,
          ticketDetails.return_ticket,
          appType,
        ),
        ticketDetails.pg_type,
        ticketDetails.total_promo_amount,
        'bus',
        ticketDetails.return_ticket.reservation_id,
      );
    }
  }

  if (isAtBooking && ticketDetails) {
    // console.log('AT booking enhanced ecommerce analytics----', this.props);
    const {
      txn_subtype,
      pickup_address,
      service_pricing_id,
      price,
      service_provider,
      service_type,
      payment_type,
    } = ticketDetails.onward_ticket;

    if (!gtagCalled) {
      CommonService.googleProductPurchase(
        [
          {
            name: txn_subtype + ' ' + pickup_address,
            id: service_pricing_id,
            price: price,
            brand: service_provider,
            category: 'transfer',
          },
        ],
        payment_type,
        null,
        'transfer',
        service_pricing_id,
      );
      gtagCalled = true;
    }
  }

  if (isAtBooking && ticketDetails && !ecoomerceSaleAdded) {
    if (ticketDetails && ticketDetails.return_pdf_url != '') {
      sendATData(ticketDetails.onward_ticket, appType, true, ticketDetails.return_ticket);
    } else {
      sendATData(ticketDetails.onward_ticket, appType, false, null);
    }

    ecoomerceSaleAdded = true;
  }

  return (
    <div className="pb-payment-details-booking-success ">
      <KuposSuccessFailure
        t={t}
        success={success}
        title={
          success
            ? i18next.language == 'es'
              ? '¡Listo!'
              : 'All set!'
            : i18next.language == 'es'
            ? '¡Lo sentimos!'
            : "We're sorry"
        }
        subtitle={
          success
            ? i18next.language == 'es'
              ? appType == 'one_click'
                ? 'Tu tarjeta ha sido guardada con éxito para facilitar tus próximas compras.'
                : 'Tu compra fue procesada con éxito. Te enviamos los detalles de tu compra a tu correo electrónico junto con el e-ticket o pasaje electrónico que necesitas para viajar. Si no lo consigues, recuerda revisar tu bandeja de correo no deseado o spam.'
              : // : 'Tu compra fue procesada con éxito. Te enviamos los detalles de la compra a tu correo electrónico. Si no lo consigues, recuerda revisar tu bandeja de correo no deseado o spam.'
              appType == 'one_click'
              ? 'Your card has been successfully saved to make your next purchases easier!'
              : "Your purchase was processed succesfully. We sent you all the transaction details to your email account. If you can't find it, don't forget to take a look at your spam folder."
            : i18next.language == 'es'
            ? 'Algo salió mal con tu compra y no pudo ser procesada correctamente.'
            : "Something went wrong with your purchase and we couldn't process it correctly."
        }
        infoText={
          success
            ? i18next.language == 'es'
              ? '¡Gracias por comprar con nosotros!'
              : 'Thanks for choosing us!'
            : i18next.language == 'es'
            ? 'Por favor intenta nuevamente'
            : 'Please try again one more time!'
        }
      >
        {loading ? (
          <div className="ticket-details-loader">
            <span>.</span>
            {/* <span>Loading...</span> */}
          </div>
        ) : success ? (
          <div className="successful-purchase-buttons font12">
            {purchaseType == 'bip_recharge' || appType == 'one_click' ? (
              <button
                className="kupos-button active"
                style={{ textDecoration: 'none' }}
                onClick={() => history.push('/my-account')}
              >
                <span>{i18next.language == 'es' ? 'Mi Cuenta' : 'My Account'}</span>
              </button>
            ) : (
              <button
                className="kupos-button active"
                onClick={() => {
                  ticketDetails.return_ticket && !isAtBooking
                    ? setShowModal(true)
                    : isAtBooking &&
                      ticketDetails.return_pdf_url &&
                      ticketDetails.return_pdf_url !== ''
                    ? setShowModal(true)
                    : window.open(
                        isAtBooking && ticketDetails
                          ? ticketDetails.onward_pdf_url
                          : ticketDetails.print_pdf_url,
                        '_blank',
                      );
                }}
              >
                <span>
                  {i18next.language == 'es' ? 'Descarga tu pasaje' : 'Download your proof'}
                  {/* {i18next.language == 'es' ? 'Descarga tu pasaje' : 'Download your ticket'} */}
                </span>
              </button>
            )}

            <button
              className="kupos-button2 no-underline-hover"
              style={{ textDecoration: 'none' }}
              onClick={() => history.push(`/${i18next.language}/pages/contact`)}
            >
              {i18next.language == 'es' ? 'Contáctanos' : 'Contact us'}
            </button>
            <button onClick={() => history.push('/')} className="kupos-button active">
              {i18next.language == 'es' ? 'Volver al inicio' : 'Back to top'}
            </button>
          </div>
        ) : (
          <FailureBody t={t} />
        )}
      </KuposSuccessFailure>

      <KuposModalWithButtons
        // size="lg"
        buttonWidth="350px"
        onHide={() => {
          setShowModal(false);
        }}
        showModal={showModal}
        // title="¿Está seguro que desea cerrar su sesión?"
        showButton1={true}
        buttonText1={t('RESULTS_PAGE.GOING_TICKET')}
        onButtonClick1={() => {
          window.open(
            isAtBooking ? ticketDetails.onward_pdf_url : ticketDetails.print_pdf_url,
            '_blank',
          );
        }}
        showButton2={true}
        buttonText2={t('RESULTS_PAGE.RETURN_TICKET')}
        onButtonClick2={() => {
          window.open(
            isAtBooking ? ticketDetails.return_pdf_url : ticketDetails.return_ticket.print_pdf_url,
            '_blank',
          );
        }}
      />
    </div>
  );
}

export default withTranslation('common')(BookingSuccess);

// class BookingSuccess extends Component {
//   static propTypes = {
//     loading: PropTypes.bool,
//     ticketDetails: PropTypes.object,
//     success: PropTypes.bool,
//     history: PropTypes.object,
//     appType: PropTypes.string,
//     t: PropTypes.func,
//     isAtBooking: PropTypes.bool,
//   };
//   constructor(props) {
//     super(props);
//     this.state = {};
//   }

//   componentDidMount() {
//     window.scrollTo(0, 0);

//     console.log('All props in BookingSuccess page are------', this.props);
//   }

//   renderFailureBody = () => {
//     return (
//       <div className="cancellation-fail-transaction kupos-card content-container light-text font12">
//         <div className="font13">
//           {this.props.t('RESULTS_PAGE.WHAT_WRONG.NORMAL')}
//           <span className="bold-text"> {this.props.t('RESULTS_PAGE.WHAT_WRONG.BOLD')}</span>
//         </div>

//         <div className=" display-flex icon-text-section">
//           <img src="/images/icons/icon-countdown.png" />
//           <span>{this.props.t('RESULTS_PAGE.TIME_REJECT')}</span>
//         </div>

//         <div className=" display-flex icon-text-section">
//           <img src="/images/icon_card.png" />
//           <span>{this.props.t('RESULTS_PAGE.BANK_REJECT')}</span>
//         </div>

//         <div className=" display-flex icon-text-section">
//           <img src="/images/icon_wifi.png" />
//           <span>{this.props.t('RESULTS_PAGE.INTERNET_REJECT')}</span>
//         </div>

//         <div className="font13 title2">
//           <span className="bold-text">{this.props.t('RESULTS_PAGE.WHAT_CAN_YOU_DO')}</span>
//         </div>

//         <div className="my-3">{this.props.t('RESULTS_PAGE.BEST_SERVICE')}</div>

//         {/* <div className=" display-flex icon-text-section">
//            <img src="/images/icon_whatsapp.png" />
//            <span>
//              Puede que hayas tenido un problema o baja conexión a Internet haciendo que la
//              transacción fallara.
//            </span>
//          </div> */}
//       </div>
//     );
//   };

//   sendData = (ticket, category, isRT = false, returnTicket) => {
//     console.log('Ticket for Gtag -------------', ticket);
//     // console.log(
//     //   'Ticket for Gtag lengthhhhhhhhhhh -------------',
//     //   Object.keys(ticket.seat_Details.seat_details).length,
//     // );
//     (window.dataLayer || []).push({
//       event: 'kupos_ecom_event',
//       transactionId: isRT ? returnTicket : ticket.pnr_number, // Transaction ID - this is normally generated by your system.
//       transactionAffiliation: 'https://kupos.cl', // Affiliation or store name
//       transactionTotal: ticket.total_booked_amount, // Grand Total
//       transactionTax: '0', // Tax.
//       transactionShipping: '0', // Shipping cost
//       transactionProducts: [
//         {
//           sku: ticket.pnr_number, // SKU/code.
//           name: category + ' ticket', // Product name.
//           category: category, // Category or variation.
//           price: ticket.total_booked_amount, // Unit price.
//           quantity: Object.keys(ticket.seat_Details.seat_details).length,
//         },
//       ],
//     });
//   };

//   sendATData = (ticket, category = 'transfer', isRT = false, returnTicket) => {
//     console.log('Ticket for Gtag -------------', ticket);
//     // console.log(
//     //   'Ticket for Gtag lengthhhhhhhhhhh -------------',
//     //   Object.keys(ticket.seat_Details.seat_details).length,
//     // );
//     (window.dataLayer || []).push({
//       event: 'kupos_ecom_event',
//       transactionId: isRT ? returnTicket.pnr_id : ticket.pnr_id, // Transaction ID - this is normally generated by your system.
//       transactionAffiliation: 'https://kupos.com', // Affiliation or store name
//       transactionTotal: ticket.total_amount, // Grand Total
//       transactionTax: '0', // Tax.
//       transactionShipping: '0', // Shipping cost
//       transactionProducts: [
//         {
//           sku: ticket.pnr_id, // SKU/code.
//           name: 'airport transfer ticket', // Product name.
//           category: 'transfer', // Category or variation.
//           price: ticket.total_amount, // Unit price.
//           quantity: returnTicket
//             ? Number(ticket.net_seats) + Number(returnTicket.net_seats)
//             : Number(ticket.net_seats),
//         },
//       ],
//     });
//   };

//   render() {
//     console.log('Ticket details--------------', this.props);
//     console.log('Ticket details appType-----------', this.props.appType);
//     console.log('this.props.purchaseType -----------', this.props.purchaseType);

//     if (this.props.ticketDetails && this.props.ticketDetails.seat_Details) {
//       // gtag ecommerce event checkout function
//       CommonService.googleProductPurchase(
//         CommonService.convertBusServiceToGoogleProduct(
//           this.props.ticketDetails.seat_Details.seat_details,
//           this.props.ticketDetails,
//           this.props.appType,
//         ),
//         this.props.ticketDetails.pg_type,
//         this.props.ticketDetails.total_promo_amount,
//         'bus',
//         this.props.ticketDetails.reservation_id,
//       );

//       //gtag Raqib
//       if (this.props.ticketDetails && this.props.ticketDetails.return_ticket) {
//         this.sendData(
//           this.props.ticketDetails,
//           this.props.appType,
//           true,
//           window.location.pathname.split('/')[3],
//         );
//       } else {
//         this.sendData(this.props.ticketDetails, this.props.appType, false, null);
//       }

//       // return
//       if (
//         this.props.ticketDetails.return_ticket &&
//         this.props.ticketDetails.return_ticket.seat_Details
//       ) {
//         CommonService.googleProductPurchase(
//           CommonService.convertBusServiceToGoogleProduct(
//             this.props.ticketDetails.return_ticket.seat_Details.seat_details,
//             this.props.ticketDetails.return_ticket,
//             this.props.appType,
//           ),
//           this.props.ticketDetails.pg_type,
//           this.props.ticketDetails.total_promo_amount,
//           'bus',
//           this.props.ticketDetails.return_ticket.reservation_id,
//         );
//       }
//     }

//     if (this.props.isAtBooking && this.props.ticketDetails) {
//       console.log('AT booking enhanced ecommerce analytics----', this.props);
//       const {
//         txn_subtype,
//         pickup_address,
//         service_pricing_id,
//         price,
//         service_provider,
//         service_type,
//         payment_type,
//       } = this.props.ticketDetails.onward_ticket;

//       if (!this.gtagCalled) {
//         CommonService.googleProductPurchase(
//           [
//             {
//               name: txn_subtype + ' ' + pickup_address,
//               id: service_pricing_id,
//               price: price,
//               brand: service_provider,
//               category: 'transfer',
//             },
//           ],
//           payment_type,
//           null,
//           'transfer',
//           service_pricing_id,
//         );
//         this.gtagCalled = true;
//       }
//     }

//     if (this.props.isAtBooking && this.props.ticketDetails && !this.ecoomerceSaleAdded) {
//       if (this.props.ticketDetails && this.props.ticketDetails.return_pdf_url != '') {
//         this.sendATData(
//           this.props.ticketDetails.onward_ticket,
//           this.props.appType,
//           true,
//           this.props.ticketDetails.return_ticket,
//         );
//       } else {
//         this.sendATData(this.props.ticketDetails.onward_ticket, this.props.appType, false, null);
//       }

//       this.ecoomerceSaleAdded = true;
//     }

//     return (
//       <div className="pb-payment-details-booking-success ">
//         <KuposSuccessFailure
//           t={this.props.t}
//           success={this.props.success}
//           title={
//             this.props.success
//               ? i18next.language == 'es'
//                 ? '¡Listo!'
//                 : 'All set!'
//               : i18next.language == 'es'
//               ? '¡Lo sentimos!'
//               : "We're sorry"
//           }
//           subtitle={
//             this.props.success
//               ? i18next.language == 'es'
//                 ? this.props.appType == 'one_click'
//                   ? 'Tu tarjeta ha sido guardada con éxito para facilitar tus próximas compras.'
//                   : 'Tu compra fue procesada con éxito. Te enviamos los detalles de la compra a tu correo electrónico. Si no lo consigues, recuerda revisar tu bandeja de correo no deseado o spam.'
//                 : this.props.appType == 'one_click'
//                 ? 'Your card has been successfully saved to make your next purchases easier!'
//                 : "Your purchase was processed succesfully. We sent you all the transaction details to your email account. If you can't find it, don't forget to take a look at your spam folder."
//               : i18next.language == 'es'
//               ? 'Algo salió mal con tu compra y no pudo ser procesada correctamente.'
//               : "Something went wrong with your purchase and we couldn't process it correctly."
//           }
//           infoText={
//             this.props.success
//               ? i18next.language == 'es'
//                 ? '¡Gracias por comprar con nosotros!'
//                 : 'Thanks for choosing us!'
//               : i18next.language == 'es'
//               ? 'Por favor intenta nuevamente'
//               : 'Please try again one more time!'
//           }
//         >
//           {this.props.loading ? (
//             <div className="ticket-details-loader">
//               <span>.</span>
//               {/* <span>Loading...</span> */}
//             </div>
//           ) : this.props.success ? (
//             <div className="successful-purchase-buttons font12">
//               {this.props.purchaseType == 'bip_recharge' || this.props.appType == 'one_click' ? (
//                 <button
//                   className="kupos-button active"
//                   style={{ textDecoration: 'none' }}
//                   onClick={() => this.props.history.push('/my-account')}
//                 >
//                   <span>{i18next.language == 'es' ? 'Mi Cuenta' : 'My Account'}</span>
//                 </button>
//               ) : (
//                 <button
//                   className="kupos-button active"
//                   onClick={() => {
//                     this.props.ticketDetails.return_ticket && !this.props.isAtBooking
//                       ? this.setState({ showModal: true })
//                       : this.props.isAtBooking &&
//                         this.props.ticketDetails.return_pdf_url &&
//                         this.props.ticketDetails.return_pdf_url !== ''
//                       ? this.setState({ showModal: true })
//                       : window.open(
//                           this.props.isAtBooking && this.props.ticketDetails
//                             ? this.props.ticketDetails.onward_pdf_url
//                             : this.props.ticketDetails.print_pdf_url,
//                           '_blank',
//                         );
//                   }}
//                 >
//                   <span>
//                     {i18next.language == 'es' ? 'Descarga tu pasaje' : 'Download your ticket'}
//                   </span>
//                 </button>
//               )}

//               <button
//                 className="kupos-button2 no-underline-hover"
//                 style={{ textDecoration: 'none' }}
//                 onClick={() => this.props.history.push(`/${i18next.language}/pages/contact`)}
//               >
//                 <span>{i18next.language == 'es' ? 'Contáctanos' : 'Contact us'}</span>
//               </button>
//               {/* <button
//                 className="kupos-button2"
//                 onClick={() => this.props.history.push('/pages/contact')}
//               >
//                 <span>Contáctanos</span>
//               </button> */}
//             </div>
//           ) : (
//             this.renderFailureBody()
//           )}
//         </KuposSuccessFailure>

//         <KuposModalWithButtons
//           // size="lg"
//           buttonWidth="350px"
//           onHide={() => {
//             this.setState({ showModal: false });
//           }}
//           showModal={this.state.showModal}
//           // title="¿Está seguro que desea cerrar su sesión?"
//           showButton1={true}
//           buttonText1={this.props.t('RESULTS_PAGE.GOING_TICKET')}
//           onButtonClick1={() => {
//             window.open(
//               this.props.isAtBooking
//                 ? this.props.ticketDetails.onward_pdf_url
//                 : this.props.ticketDetails.print_pdf_url,
//               '_blank',
//             );
//             // this.setState({ showModal: false });
//           }}
//           showButton2={true}
//           buttonText2={this.props.t('RESULTS_PAGE.RETURN_TICKET')}
//           onButtonClick2={() => {
//             window.open(
//               this.props.isAtBooking
//                 ? this.props.ticketDetails.return_pdf_url
//                 : this.props.ticketDetails.return_ticket.print_pdf_url,
//               '_blank',
//             );
//             // this.setState({ showModal: false });
//           }}
//         />
//       </div>
//     );
//   }
// }

// export default withTranslation('common')(BookingSuccess);



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusPaymentDetails/BookingSuccess/BookingSuccess.js